/* eslint-disable max-classes-per-file */
class ExtendableError extends Error {
  statusCode: number;

  constructor(message: string) {
    super(message);

    this.name = this.constructor.name;
    this.statusCode = (this.constructor as any).statusCode;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export class NotFound extends ExtendableError {}
/* eslint-enable max-classes-per-file */
